export interface BlogPost {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  image: string;
  category: string;
  readTime: string;
  date: string;
  slug: string;
}

export const blogPosts: BlogPost[] = [
  {
    id: 1,
    title: "Vivir en la Costa Blanca: el estilo de vida mediterráneo que todos buscan",
    excerpt: "La Costa Blanca se ha convertido en uno de los destinos más deseados de Europa para vivir, invertir o disfrutar de una segunda residencia.",
    content: `La Costa Blanca se ha convertido en uno de los destinos más deseados de Europa para vivir, invertir o disfrutar de una segunda residencia. Con más de 300 días de sol al año, playas espectaculares y un estilo de vida relajado, cada vez más personas deciden mudarse a esta región del Mediterráneo.

Ubicada en la provincia de Alicante, la Costa Blanca ofrece una combinación perfecta entre naturaleza, infraestructura moderna y una gran calidad de vida.

Entre las razones por las que tantas personas eligen vivir aquí destacan:

• Clima cálido durante todo el año
• Hermosas playas del Mediterráneo
• Comunidades internacionales
• Excelente gastronomía
• Un estilo de vida tranquilo y saludable

Para muchos compradores extranjeros, esta región no es solo un destino turístico, sino un lugar ideal para comenzar una nueva etapa de vida.

En Red Lions Realty ayudamos a nuestros clientes a encontrar la propiedad perfecta para disfrutar del auténtico estilo de vida mediterráneo.`,
    image: "https://public.readdy.ai/ai/img_res/447cef25efeaccb36e2b667942c4c57b.jpg",
    category: "Estilo de vida",
    readTime: "5 min",
    date: "2024-01-15",
    slug: "vivir-en-la-costa-blanca-estilo-de-vida-mediterraneo"
  },
  {
    id: 2,
    title: "Las mejores zonas para comprar propiedad en Orihuela Costa",
    excerpt: "La zona costera de Orihuela Costa es uno de los destinos más populares para compradores internacionales que buscan propiedades en España.",
    content: `La zona costera de Orihuela Costa es uno de los destinos más populares para compradores internacionales que buscan propiedades en España. Su combinación de playas, campos de golf, centros comerciales y comunidades internacionales la convierten en un lugar ideal para vivir o invertir.

Entre las zonas más demandadas se encuentran:

La Zenia

Una zona muy animada conocida por su playa y por el famoso centro comercial Zenia Boulevard, uno de los más grandes de la provincia.

Playa Flamenca

Una zona residencial muy popular con excelentes restaurantes, paseos marítimos y vistas al mar.

Villamartín

Conocida por su prestigioso campo de golf y sus hermosas urbanizaciones.

Cabo Roig

Una de las áreas más exclusivas, con villas de lujo y espectaculares vistas al Mediterráneo.

Cada zona tiene su propio encanto, lo que hace de Orihuela Costa un lugar ideal para encontrar la propiedad perfecta.`,
    image: "https://public.readdy.ai/ai/img_res/edited_905f8d6c5d9ddc97d881cec357c07b05_fba25716.jpg",
    category: "Zonas",
    readTime: "6 min",
    date: "2024-01-20",
    slug: "mejores-zonas-comprar-propiedad-orihuela-costa"
  },
  {
    id: 3,
    title: "Cómo comprar una propiedad en España siendo extranjero",
    excerpt: "Comprar una propiedad en España es un proceso relativamente sencillo, incluso para personas que no son residentes.",
    content: `Comprar una propiedad en España es un proceso relativamente sencillo, incluso para personas que no son residentes. De hecho, miles de compradores internacionales adquieren viviendas cada año en el país.

El primer paso es obtener el NIE (Número de Identificación de Extranjero). Este número es necesario para realizar cualquier trámite financiero en España, incluida la compra de una propiedad.

El proceso de compra suele incluir los siguientes pasos:

• Reserva de la propiedad
• Firma de un contrato privado de compraventa
• Firma final ante notario

La firma ante notario es el momento en que la propiedad se transfiere oficialmente al nuevo propietario.

Contar con el apoyo de una agencia inmobiliaria profesional puede hacer que todo el proceso sea más sencillo, seguro y transparente.

En Red Lions Realty acompañamos a nuestros clientes durante todo el proceso de compra.`,
    image: "https://readdy.ai/api/search-image?query=professional%20real%20estate%20signing%20contract%20spain%20foreign%20buyer%20notary%20office%20elegant%20modern%20interior%20people%20happy%20documents%20pen%20table%20bright%20natural%20light&width=1200&height=600&seq=blog3foreignbuyer&orientation=landscape",
    category: "Guía de compra",
    readTime: "7 min",
    date: "2024-01-25",
    slug: "como-comprar-propiedad-espana-siendo-extranjero"
  },
  {
    id: 4,
    title: "Cuánto cuesta comprar una casa en la Costa Blanca",
    excerpt: "El mercado inmobiliario en la Costa Blanca sigue siendo uno de los más atractivos de España.",
    content: `El mercado inmobiliario en la Costa Blanca sigue siendo uno de los más atractivos de España. En comparación con otras zonas del Mediterráneo, los precios todavía ofrecen una excelente relación calidad-precio.

El costo de una propiedad depende de factores como la ubicación, el tipo de vivienda y la cercanía al mar.

Algunos ejemplos aproximados de precios son:

• Apartamentos desde 120.000 €
• Casas adosadas desde 180.000 €
• Villas independientes desde 300.000 €

Zonas como Orihuela Costa siguen siendo especialmente populares gracias a su cercanía a playas, campos de golf y servicios internacionales.

Esto hace que la Costa Blanca sea un lugar ideal tanto para vivir como para invertir.`,
    image: "https://public.readdy.ai/ai/img_res/edited_1c461a67ab791ba4427371712b7eb684_a4eb7dc5.jpg",
    category: "Precios",
    readTime: "5 min",
    date: "2024-02-01",
    slug: "cuanto-cuesta-comprar-casa-costa-blanca"
  },
  {
    id: 5,
    title: "Por qué invertir en propiedades en la Costa Blanca es una gran oportunidad",
    excerpt: "La Costa Blanca se ha consolidado como uno de los destinos inmobiliarios más atractivos de Europa.",
    content: `La Costa Blanca se ha consolidado como uno de los destinos inmobiliarios más atractivos de Europa.

Cada año miles de compradores internacionales buscan propiedades en esta región por diversas razones.

Entre las principales ventajas de invertir aquí destacan:

Alta demanda turística

Millones de turistas visitan la Costa Blanca cada año, lo que genera una gran demanda de alquiler vacacional.

Precios competitivos

En comparación con otros destinos mediterráneos, el mercado inmobiliario sigue ofreciendo precios accesibles.

Gran calidad de vida

El clima, la gastronomía, el mar y el estilo de vida mediterráneo convierten a esta región en un lugar perfecto para vivir o pasar largas temporadas.

Por estas razones, muchas personas deciden comprar una propiedad aquí tanto para disfrutarla como para obtener rentabilidad a largo plazo.

En Red Lions Realty ayudamos a nuestros clientes a encontrar las mejores oportunidades inmobiliarias en la Costa Blanca.`,
    image: "https://readdy.ai/api/search-image?query=real%20estate%20investment%20concept%20costa%20blanca%20spain%20property%20growth%20chart%20keys%20house%20model%20financial%20success%20mediterranean%20properties%20modern%20composition%20professional%20photography&width=1200&height=600&seq=blog5investment&orientation=landscape",
    category: "Inversión",
    readTime: "6 min",
    date: "2024-02-05",
    slug: "por-que-invertir-propiedades-costa-blanca"
  }
];

export const blogCategories = [
  "Todas",
  "Estilo de vida",
  "Zonas",
  "Guía de compra",
  "Precios",
  "Inversión"
];